// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__dA9ZD","spin":"Spinner_spin__6HA+F"};